import { css, keyframes } from "@emotion/react"
import { above } from "@mkt/ui/styles/Breakpoints"
import { colors } from "../../../styles/Tokens"

const ContainerDesktop = css`
  ${above["m"]} {
    width: 33%;
  }
`
const OverFlowHidden = css`
  overflow: hidden;
`

const LoadingSkeleton = keyframes`
    100% {
        transform: translateX(100%);
    }
`

const BeforeContent = css`
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    transparent,
    ${colors.gray.lightest},
    transparent
  );
  animation: ${LoadingSkeleton} 0.8s infinite;
`

const DisplayFlexWithJustifyCenter = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const ContainerLoading = css`
  ${DisplayFlexWithJustifyCenter};
  align-items: center;
  background-color: ${colors.white};
  flex-wrap: wrap;
  margin-bottom: 12px;
  min-height: 290px;
  padding: 20px 16px;
  width: 100%;
`

export const LoadingContentImage = css`
  ${ContainerDesktop};
  ${DisplayFlexWithJustifyCenter};
  align-items: center;
  min-height: 100px;
  width: 100%;
`

export const LoadingImage = css`
  ${OverFlowHidden};
  background-color: ${colors.gray.light};
  border-radius: 12px;
  display: block;
  height: 100px;
  max-width: 100px;
  position: relative;
  width: 100%;

  &:before {
    ${BeforeContent};
  }
`

export const LoadingInformation = css`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100px;
  width: 50%;

  ${ContainerDesktop};
`

export const LoadingContentButton = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100px;
  width: 50%;

  ${ContainerDesktop};
`

export const LoadingTitle = css`
  ${OverFlowHidden};
  background-color: ${colors.gray.light};
  height: 20px;
  margin-bottom: 12px;
  position: relative;
  width: 100%;

  &:before {
    ${BeforeContent};
  }
`

export const LoadingText = css`
  ${OverFlowHidden};
  background-color: ${colors.gray.light};
  height: 15px;
  margin-bottom: 10px;
  position: relative;
  width: 80%;

  &:before {
    ${BeforeContent};
  }
`

export const LoadingButton = css`
  ${OverFlowHidden};
  ${OverFlowHidden};
  background-color: ${colors.gray.light};
  border-radius: 25px;
  height: 45px;
  margin-bottom: 16px;
  position: relative;
  width: 60%;

  &:before {
    ${BeforeContent};
  }
`

export const LoadingMore = css`
  ${OverFlowHidden};
  background-color: ${colors.gray.light};
  height: 15px;
  margin-top: 12px;
  position: relative;
  width: 40%;

  &:before {
    ${BeforeContent};
  }
`
